import { useState, useCallback } from 'react';
import { ConfirmationType } from '../components/ConfirmationModal';

interface ConfirmationOptions {
  title: string;
  message: string;
  type?: ConfirmationType;
  confirmText?: string;
  cancelText?: string;
  showCancelButton?: boolean;
  confirmButtonColor?: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

interface ConfirmationState extends ConfirmationOptions {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const useConfirmation = () => {
  const [confirmation, setConfirmation] = useState<ConfirmationState | null>(null);

  const showConfirmation = useCallback((
    options: ConfirmationOptions,
    onConfirm: () => void,
    onCancel?: () => void
  ) => {
    setConfirmation({
      ...options,
      open: true,
      onConfirm: () => {
        onConfirm();
        setConfirmation(null);
      },
      onCancel: () => {
        onCancel?.();
        setConfirmation(null);
      },
    });
  }, []);

  const hideConfirmation = useCallback(() => {
    setConfirmation(null);
  }, []);

  return {
    confirmation,
    showConfirmation,
    hideConfirmation,
  };
}; 